/* "This tab is mid-wizard" for one workspace (guided onboarding P1, D-8). A refresh on /setup-workspace
   resumes the questions only for the workspace marked here. The vendor's customer form marks the workspace
   it just made, so turning "Connect AutoCount" off lands on the same guided first workflow (VL-10 of
   docs/billing-vendor-lead-onboarding-proposal.md, in the SVN repo). */
const IN_PROGRESS_KEY = 'ftsOnboardingInProgress';

export function markOnboardingInProgress(workspaceId) {
  if (!workspaceId) return;
  try { sessionStorage.setItem(IN_PROGRESS_KEY, String(workspaceId)); } catch (err) { /* private mode */ }
}

export function readOnboardingInProgress() {
  try { return sessionStorage.getItem(IN_PROGRESS_KEY); } catch (err) { return null; }
}

export function clearOnboardingInProgress() {
  try { sessionStorage.removeItem(IN_PROGRESS_KEY); } catch (err) { /* private mode */ }
}
